import {ChangeDetectorRef, Component, Input, OnInit, inject} from '@angular/core';
import {BusinessPicklistRow} from '../../_data/reports/business/response/business-picklist-row';
import {Bizinquiry} from '../../_data/reports/business/request/bizinquiry';
import {GoogleMapsService, MapGeocoderResponse} from '../../_services/google/google-maps.service';
import {of} from 'rxjs';
import {BusinessRequest} from '../../_data/reports/business/request/business-request';
import {Router, RouterLink} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {exists} from '../../_utils/operators';
import {GoogleMap, MapMarker} from '@angular/google-maps';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-business-search-result',
    templateUrl: './business-search-result.component.html',
    styleUrls: ['./business-search-result.component.scss'],
    imports: [RouterLink, GoogleMap, MapMarker, TranslateModule]
})
export class BusinessSearchResultComponent implements OnInit {

  @Input() bizInquiry: Bizinquiry;
  @Input() business: BusinessPicklistRow;
  @Input() qualifier: string;
  @Input() searchType: string;
  @Input() productDescription: string;

  loading: boolean = false;
  isMapShowing: boolean = false;
  geocodeSuccess = false;

  options: google.maps.MapOptions = {
    center: {lat: 0, lng: 0},
    zoom: 15
  };

  markerOptions: google.maps.MarkerOptions = {draggable: false};
  markerPosition: google.maps.LatLngLiteral = {lat: 0, lng: 0};

  private readonly router = inject(Router);
  private readonly googleMapsService = inject(GoogleMapsService);
  private readonly cdRef = inject(ChangeDetectorRef);

  private geocodeBusiness() {
    const addr = [];
    addr.push(this.business.streets && this.business.streets.find(s => !!s));
    addr.push(this.business.postals && this.business.postals.find(s => !!s));
    const addressToGeocode = addr.filter(v => !!v).join(',');
    this.googleMapsService.geocodeAddress(addressToGeocode).pipe(
      catchError(err => {
        console.info(`Geocode failed`, err);
        this.loading = false;
        this.geocodeSuccess = false;
        return of(null);
      }),
      exists()
    ).subscribe((location: MapGeocoderResponse) => {
      this.lat = location?.results?.[0]?.geometry?.location?.lat();
      this.lng = location?.results?.[0]?.geometry?.location?.lng();
      this.loading = false;
      this.geocodeSuccess = true;
      this.cdRef.detectChanges();
    });
  }

  ngOnInit() {
  }

  showMap() {
    this.loading = true;
    this.isMapShowing = true;
    this.geocodeBusiness();
  }

  hideMap() {
    this.isMapShowing = false;
  }

  get businessRequest(): BusinessRequest {
    return {
      bizInquiry:         this.bizInquiry,
      business:           this.business,
      inquiryQualifier:   this.qualifier,
      productDescription: this.productDescription,
      searchType:         this.searchType
    };
  }

  private set lat(lat: number) {
    this.options.center.lat = lat;
    this.markerPosition.lat = lat;
  }

  private set lng(lng: number) {
    this.options.center.lng = lng;
    this.markerPosition.lng = lng;
  }

}
